import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getLineItemPixels } from './helpers'
import { formatOptionsList } from '../../../../../../features/formatters'
import { renderArrayObjectValueWithComas } from '../../../../../Facebook/LineItemForms/LineItemFacebookEdit/Sections/CustomAudiencesSection/helpers'

import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

const PixelsSectionPreview = ({ lineItem }) => {
  const selectedDV360AdAccount = useSelector(selectedDV360AdAccountSelector)
  const { dv360_floodlight_groups: dv360FloodlightGroups } = selectedDV360AdAccount

  const formattedPixels = useMemo(
    () =>
      formatOptionsList({
        list: dv360FloodlightGroups,
        labelName: 'name',
        valueName: 'id'
      }),
    [dv360FloodlightGroups]
  )

  const lineItemPixels = useMemo(() => {
    return getLineItemPixels(lineItem, formattedPixels)
  }, [lineItem, formattedPixels])

  return <p>{renderArrayObjectValueWithComas(lineItemPixels, 'label')}</p>
}

export default PixelsSectionPreview
